/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterTransactionDTO
 */
export interface RegisterTransactionDTO {
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionDTO
     */
    personId?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterTransactionDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionDTO
     */
    cardTypeId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RegisterTransactionDTO
     */
    transactionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionDTO
     */
    carePrincipalId?: string;
}

export function RegisterTransactionDTOFromJSON(json: any): RegisterTransactionDTO {
    return RegisterTransactionDTOFromJSONTyped(json, false);
}

export function RegisterTransactionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterTransactionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'transactionDate': !exists(json, 'transactionDate') ? undefined : (new Date(json['transactionDate'])),
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
    };
}

export function RegisterTransactionDTOToJSON(value?: RegisterTransactionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'personId': value.personId,
        'amount': value.amount,
        'cardTypeId': value.cardTypeId,
        'transactionDate': value.transactionDate === undefined ? undefined : (value.transactionDate.toISOString().substr(0,10)),
        'carePrincipalId': value.carePrincipalId,
    };
}

